import React from 'react';
export const Adobe = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`w-icon ${props.className ? props.className : ''}`}><path d="M20,1 L20,19.0010671 L12.6072222,1 L20,1 Z M7.39861111,1 L-1.68220993e-12,19.0010671 L-1.68220993e-12,1 L7.39861111,1 Z M10.0027778,7.26488497 L14.7138889,19 L11.6269444,19 L10.2172222,15.5814318 L6.77027778,15.5814318 L10.0027778,7.26488497 Z" fillRule="evenodd" /></svg>
);
